module.exports = __webpack_public_path__ + "media/tlzbg.7e5f0e3c.mp4";